import React from 'react';

interface RumbleApiHelpProps {
  isOpen: boolean;
  onClose: () => void;
}

const RumbleApiHelp: React.FC<RumbleApiHelpProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-black border-2 border-white p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">How to Get Your Rumble Livestream API URL</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <i className="fa-solid fa-times text-xl"></i>
          </button>
        </div>

        <div className="space-y-6">
          <div className="border-2 border-dashed border-gray-600 p-4">
            <h3 className="text-white font-bold mb-2">Step 1: Navigate to Rumble API Settings</h3>
            <p className="text-gray-300 mb-3">
              Go to{' '}
              <a 
                href="https://rumble.com/account/livestream-api" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 underline hover:text-blue-300"
              >
                https://rumble.com/account/livestream-api
              </a>
            </p>
            <p className="text-gray-400 text-sm">
              Make sure you're logged into your Rumble account
            </p>
          </div>

          <div className="border-2 border-dashed border-gray-600 p-4">
            <h3 className="text-white font-bold mb-2">Step 2: Generate Your API Key</h3>
            <p className="text-gray-300 mb-3">
              Click the "Generate API key" button
            </p>
            <div className="bg-gray-900 p-3 rounded border border-gray-700">
              <div className="flex items-center justify-center">
                <div className="bg-green-600 text-white px-6 py-2 rounded font-medium">
                  Generate API key
                </div>
              </div>
              <p className="text-gray-500 text-xs mt-2 text-center">
                (This is what the button looks like)
              </p>
            </div>
          </div>

          <div className="border-2 border-dashed border-gray-600 p-4">
            <h3 className="text-white font-bold mb-2">Step 3: Copy Your API URL</h3>
            <p className="text-gray-300 mb-3">
              After generating, you'll see your API URL with a copy button:
            </p>
            <div className="bg-gray-900 p-3 rounded border border-gray-700">
              <div className="flex items-center gap-2">
                <input 
                  className="flex-1 bg-black border border-gray-600 px-3 py-2 text-gray-400 text-sm"
                  value="rtmps://ingest.rumble.com:8443/live/YOUR_API_KEY"
                  readOnly
                />
                <button className="bg-gray-700 text-white px-3 py-2 border border-gray-600 hover:bg-gray-600">
                  <i className="fa-solid fa-copy"></i>
                </button>
              </div>
              <p className="text-gray-500 text-xs mt-2">
                Click the copy button to copy the entire URL
              </p>
            </div>
          </div>

          <div className="border-2 border-dashed border-gray-600 p-4">
            <h3 className="text-white font-bold mb-2">Step 4: Paste Into Settings</h3>
            <p className="text-gray-300">
              Come back here and paste the URL into the "Rumble Livestream API URL" field below
            </p>
          </div>

          <div className="bg-yellow-900 border-2 border-yellow-600 p-4">
            <p className="text-yellow-400 text-sm">
              <i className="fa-solid fa-exclamation-triangle mr-2"></i>
              <strong>Important:</strong> Keep your API URL private!
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="paint-button"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default RumbleApiHelp;